/**
 * @author: junjunzuo(junjunzuo@tencent.com)
 * @description: 短视频结果页
 * @Date: 2020-06-15 16:26:28
 */

import * as types from '@types';
import axios from 'axios';

export default {
  namespaced: true,
  state: () => ({
    query: '',
    shortVideo: [],
    spver: 0,
    maxEnd: 0,
    soutuiExpInfo: '',
    // 分页参数, 下一页默认从第二页开始加载
    page: 2,
    sUuid: '',
    // 后端原始返回数据
    originResult: null,
    debugInfo: null,
  }),
  mutations: {
    [types.UPDATE_SEARCH_QUERY](state, query) {
      state.query = query;
    },
    [types.UPDATE_SEARCH_SHORTVIDEO](state, shortVideo) {
      state.shortVideo = shortVideo;
    },
    [types.UPDATE_SEARCH_VIDEO_PLDTIMES](state, index) {
      const shortVideo = [...state.shortVideo];
      shortVideo[index].playedTimes += 1;
      state.shortVideo = shortVideo;
    },
    [types.UPDATE_SEARCH_VIDEO_PLDPROGRESS](state, { index, currentTime, duration }) {
      const shortVideo = [...state.shortVideo];
      if (currentTime >= 0) shortVideo[index].currentTime = currentTime;
      if (duration > 0) shortVideo[index].totalDuration = duration;
      state.shortVideo = shortVideo;
    },
    [types.UPDATE_SEARCH_VIDEO_STATUS](state, { index, status }) {
      const shortVideo = [...state.shortVideo];
      shortVideo[index].playStatus = status;
      state.shortVideo = shortVideo;
    },
    [types.UPDATE_SEARCH_SPVER](state, spver) {
      state.spver = spver;
    },
    [types.UPDATE_SEARCH_MAXEND](state, maxEnd) {
      state.maxEnd = maxEnd;
    },
    [types.UPDATE_SEARCH_STEXP_INFO](state, obj) {
      state.soutuiExpInfo = obj;
    },
    [types.UPDATE_SEARCH_PAGE](state, num) {
      state.page = num;
    },
    [types.UPDATE_SEARCH_SUUID](state, str) {
      state.sUuid = str;
    },
    [types.UPDATE_SEARCH_ORIGIN_RESULT](state, obj) {
      state.originResult = obj;
    },
    [types.UPDATE_SEARCH_DEBUG_INFO](state, obj) {
      state.debugInfo = obj;
    },
  },
  actions: {
    /**
     * 获取短视频结果页数据
     */
    async prefetchData({ commit, rootState }, { context, route }) {
      const $params = context ? context.$params : {};
      const routeName = route.name || '';
      const key = route.params.key || '';
      const params = Object.assign({}, route.query, $params, { routeName, key });
      const config = rootState.common.$config || {};
      const { qua, wxAppEnable, wxAppVersion, xWebEnable, iskd, guid, qbid, isHitKd } = config;
      if (iskd === 1 && +isHitKd === 1) {
        Object.assign(params, {
          qua,
          wxAppEnable,
          wxAppVersion,
          xWebEnable,
          iskd,
          guid,
          qbid,
          isHitKd,
        });
      }

      const result = await axios({
        url: `${types.ORIGIN_CLIENT}/napi/video/search`,
        params,
        timeout: 4500,
      }).catch(err => console.log(err));
      const { data: resData = {}, status } = (result && result.data) || {};

      if (status === 0) {
        const {
          query = '',
          shortVideo = [],
          loadEnded,
          maxEnd,
          spver,
          soutuiExpInfo,
          uuid,
          originResult = null,
          debugInfo = null,
        } = resData;

        commit(types.UPDATE_SEARCH_QUERY, query);
        commit(types.UPDATE_SEARCH_SHORTVIDEO, shortVideo);
        commit(types.UPDATE_SEARCH_MAXEND, maxEnd);
        commit(types.UPDATE_SEARCH_SPVER, spver);
        commit(types.UPDATE_SEARCH_STEXP_INFO, soutuiExpInfo);
        const loadingFinished = loadEnded || shortVideo.length >= maxEnd || !shortVideo.length;
        commit(`common/${types.UPDATE_LOADING_FINISHED}`, loadingFinished, { root: true });
        commit(types.UPDATE_SEARCH_SUUID, uuid);
        commit(types.UPDATE_SEARCH_ORIGIN_RESULT, originResult);
        commit(types.UPDATE_SEARCH_DEBUG_INFO, debugInfo);
        return result;
      }
      if (status === 301) return result;
      if (status === 404) return { status: 404 };
      return {
        status: 302,
        redirectUrl: '/?prefetch_redirect=1',
      };
    },

    /**
     * 获取短视频下一页数据
     * @param {*} route 前端路由信息
     * @param {*} callback 调用结束回调
     * @param {*} failed 调用失败回调
     * @return {*}
     */
    async getNextPageData({ state, commit, rootState }, { params, callback, failed }) {
      const { page, shortVideo, maxEnd } = { ...state };
      const paramsAlias = { page, routeName: 'v', ...params };
      const config = rootState.common.$config || {};
      const { qua, wxAppEnable, wxAppVersion, xWebEnable, iskd, guid, qbid, isHitKd } = config;
      if (iskd === 1 && +isHitKd === 1) {
        Object.assign(paramsAlias, {
          qua,
          wxAppEnable,
          wxAppVersion,
          xWebEnable,
          iskd,
          guid,
          qbid,
          isHitKd,
        });
      }

      const result = await axios({
        url: `${types.ORIGIN_CLIENT}/napi/video/shortvideo`,
        params: paramsAlias,
        timeout: 2000,
      }).catch((err) => {
        typeof failed === 'function' && failed(err);
        commit(`common/${types.UPDATE_LOADING_FINISHED}`, true, { root: true });
      });
      const { data: resData, status } = result.data || {};

      if (resData && status === 0) {
        const { shortVideoList: tmpVideo, loadEnded } = resData;
        if (!tmpVideo) {
          typeof failed === 'function' && failed('no content to load!');
          commit(`common/${types.UPDATE_LOADING_FINISHED}`, true, { root: true });
          return false;
        }
        const videos = shortVideo.concat(tmpVideo);
        commit(types.UPDATE_SEARCH_SHORTVIDEO, videos);
        if (loadEnded || videos.length >= maxEnd || !videos.length) {
          commit(`common/${types.UPDATE_LOADING_FINISHED}`, true, { root: true });
        }
        commit(types.UPDATE_SEARCH_PAGE, page + 1);
      } else {
        typeof failed === 'function' && failed('illegal response!');
        commit(`common/${types.UPDATE_LOADING_FINISHED}`, true, { root: true });
      }
      typeof callback === 'function' && callback(result);
    },
  },
};
